import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend } from "recharts";

function LineGraph({ data, xLabelKey, yLabelKey, legends = [], width, height, className = "", animation = true }) {
	return (
		<LineChart className={className} width={width} height={height} data={data} margin={{ top: 16, right: 12, left: 4, bottom: 8 }}>
			<XAxis dataKey={xLabelKey} tick={{ fontSize: 11 }} minTickGap={14} tickLine={false} axisLine={{ stroke: "#9ca3af" }} />
			<YAxis
				dataKey={yLabelKey}
				tick={{ fontSize: 11 }}
				tickLine={false}
				axisLine={{ stroke: "#9ca3af" }}
				width={40}
				allowDecimals={false}
				domain={[0, (dataMax) => Math.max(10, Math.ceil(Number(dataMax || 0) * 1.1))]}
			/>
			<Tooltip contentStyle={{ borderRadius: 8, borderColor: "#e5e7eb" }} />
			<Legend />
			{legends.map((line, i) => {
				return <Line key={i} type="linear" dataKey={line.title} stroke={line.color} activeDot={{ r: 5 }} strokeWidth={2.5} dot={{ r: 3 }} isAnimationActive={animation} />;
			})}
		</LineChart>
	);
}

export default LineGraph;
